export default __webpack_public_path__ + "static/media/no-appt.e596ad3f.svg";